import { getComponentFromName } from '@folklore/utils';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useFormats from '../../hooks/useFormats';

import * as CardComponents from '../cards/taxonomies';
import PresentationList, { PresentationListProps } from './PresentationList';

const hooks = {
    default: useFormats,
};

interface FormatsListProps extends Omit<PresentationListProps<Format>, 'cardComponent' | 'hook'> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function FormatsList({ hook = 'default', cardType, cardComponent, ...props }: FormatsListProps) {
    return (
        <PresentationList<Format>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Horizontal)
            }
        />
    );
}

export default FormatsList;
